import { z } from "zod";

export const PayStandCheckoutConfigSchema = z.object({
  env: z.string(),
  publishableKey: z.string(),
  checkoutUrl: z.string(),
  payerEmail: z.string(),
  // customerId: z.string(),
});

export type PayStandCheckoutConfigType = z.infer<
  typeof PayStandCheckoutConfigSchema
>;
